export const HSRCastoriceDPS = {
  V1: {
    // 1 target
    e0: 706626,
    e1: 866688,
    e2: 1192561,
    e3: 1274430,
    e4: 1274430,
    e5: 1354491,
    e6: 2001506,
    sig_e0: 869882,
    sig_e1: 1067916,
    sig_e2: 1480359,
    sig_e3: 1583024,
    sig_e4: 1583024,
    sig_e5: 1683736,
    sig_e6: 2493400,
    // 3 targets
    alt_e0: 1207465,
    alt_e1: 1465367,
    alt_e2: 2251991,
    alt_e3: 2347526,
    alt_e4: 2347526,
    alt_e5: 2558866,
    alt_e6: 3413080,
    alt_sig_e0: 1480179,
    alt_sig_e1: 1798389,
    alt_sig_e2: 2780564,
    alt_sig_e3: 2900153,
    alt_sig_e4: 2900153,
    alt_sig_e5: 3164598,
    alt_sig_e6: 4228672,
    // 5 targets
    e0_5targets: 1622091,
    e1_5targets: 1977833,
    e2_5targets: 3225208,
    e3_5targets: 3334408,
    e4_5targets: 3334408,
    e5_5targets: 3665800,
    e6_5targets: 4707726,
    sig_e0_5targets: 1987958,
    sig_e1_5targets: 2426344,
    sig_e2_5targets: 3978250,
    sig_e3_5targets: 4114763,
    sig_e4_5targets: 4114763,
    sig_e5_5targets: 4529209,
    sig_e6_5targets: 5824444
  }
};
